<template>
  <div class="flex min-w-200 flex-row">
    <IconCheckInCircleFilled
      class="mr-8 self-center"
      :class="animation"
      color="green"
    />
    <h3 class="heading-3 hidden self-center md:block">
      {{ i18n(translations.addedToCart) }}
    </h3>
    <h3 class="heading-3 block self-center md:hidden">
      {{
        i18n(translations.addedToCartItems, {
          count: quantity,
        })
      }}
    </h3>
  </div>
</template>

<script setup lang="ts">
import { ref, useCssModule, watch } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconCheckInCircleFilled } from '@ds/icons/IconCheckInCircleFilled'

import translations from './Title.translations'

const i18n = useI18n()
const props = defineProps<{
  quantity: number
}>()

const animation = ref()
const style = useCssModule()

watch(
  () => props.quantity,
  () => {
    animation.value = null

    requestAnimationFrame(() => {
      animation.value = style.animatedCheck
    })
  },
  { immediate: true },
)
</script>

<style module>
.animatedCheck {
  animation: checkAnimation 0.5s ease-out forwards;
}
@keyframes checkAnimation {
  0% {
    transform: scale3d(1, 1, 1);
  }
  50% {
    transform: scale3d(0.1, 0.1, 0.1);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}
</style>
